import React from "react";
import { useNavigate } from "react-router-dom";
import { Button, TextField } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { getAppServerIpAddress, setAppServerIpAddress } from "../Redux/DevDemoVariables";
import store from "../storage";

const Config = () => {
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const IPAddress = useSelector(getAppServerIpAddress);

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100vw',
      backgroundColor: 'rgb(243, 243, 243)',
      paddingTop: '50px'
    }}>
      <div>
        <TextField
          value={"https://"}
          style={{ width: "100px", marginBottom: "10px" }}
          id="filled-required"
          variant="filled"
        />
        <TextField
          label="Enter App Server IP Address"
          value={IPAddress}
          onChange={(e) => { dispatch(setAppServerIpAddress(e.target.value.trim())) }}
          id="filled-required ip"
          variant="filled"
          style={{ width: "300px", margin: "0 10px 10px 10px" }}
        />
        <TextField
          label="Port"
          value={':8989'}
          style={{ width: "100px", marginBottom: "10px" }}
          id="filled-required"
          variant="filled"
        />
      </div>
      <Button
        variant="contained"
        color="primary"
        onClick={() => {
          store.set('REACT_APP_DORI_APP_SERVER', `https://${IPAddress}`);
          navigate('/login');
        }}
      >
        Update IP Adress
      </Button>
    </div>
  );
}

export default Config;
